// eslint-disable-next-line @typescript-eslint/no-var-requires
const FR = require('./languages/fr')
// eslint-disable-next-line @typescript-eslint/no-var-requires
const EN = require('./languages/en')
export const translation = (language: any, key: any, subKey?: any) => {
   if (language === 'en') {
      if (subKey) return EN[key][0][subKey] || `missing translation for key: ${key}`
      else return EN[key] || `missing translation for key: ${key}`
   }
   if (language === 'fr') {
      if (subKey) return FR[key][0][subKey] || `missing translation for key: ${key}`
      else return FR[key] || `missing translation for key: ${key}`
   }
}
// import * as EN from './languages/en.json'
// import * as FR from './languages/fr.json'

// export const translation = (language: 'en' | 'fr', key: string, subKey?: string): string => {
//    if (language === 'en') {
//       if (subKey) return EN[key][0][subKey] || `missing translation for key: ${key}`
//       else return EN[key] || `missing translation for key: ${key}`
//    }
//    if (language === 'fr') {
//       if (subKey) return FR[key][0][subKey] || `missing translation for key: ${key}`
//       else return FR[key] || `missing translation for key: ${key}`
//    }
//    return ''
// }
